<template>
  <a
    role="button"
    :class="[
      `button button--${appearance}`,
      small && 'button--small',
      fullWidth && 'button--block',
      loading && !icon && 'button--loading',
      `${iconClassName} ${customClass}`,
      disabled && 'button--disabled',
    ]"
    @click="onButtonClick($event)"
  >
    {{ label }}
    <icon v-if="icon" class-name="button__icon" :name="icon" />
  </a>
</template>

<script>
// Components
import Icon from "../Icon/Icon.vue";

export default {
  name: "Button",
  components: {
    Icon,
  },
  props: {
    /**
     * @description
     * Button supports only Primary, Secondary, Tertiary
     */
    appearance: {
      type: String,
      validator: (val) => ["primary", "secondary", "tertiary"].includes(val),
      default: "primary",
    },
    /**
     *  @description
     * Provides the label of the button
     */
    label: {
      type: String,
      default: "",
    },
    /**
     *  @description
     * Provides the Icon Name of the button
     */
    icon: {
      type: String,
      default: "",
    },
    /**
     *  @description
     * Provides the Custom class of the button
     */
    customClass: {
      type: String,
      default: "",
    },
    /**
     *  @description
     * Button supports icon position left & right
     */
    iconPosition: {
      type: String,
      validator: (val) => ["left", "right"].includes(val),
      default: "right",
    },
    /**
     * @description
     * Checks if the Button should be disabled
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Button should be small
     */
    small: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Button should have full width
     */
    fullWidth: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Button should be icon only button
     */
    iconOnly: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Button should have a loading state
     */
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * @description
     * Handles the classNames based on the props dynamically
     */
    iconClassName() {
      return this.icon
        ? this.iconOnly
          ? "button--icon--only"
          : this.iconPosition === "left"
          ? "button--icon--left"
          : "button--icon--right"
        : "";
    },
  },
  methods: {
    /**
     * @description
     * Emits when button is clicked, parent component needs to handle
     */
    onButtonClick(event) {
      if (!this.disabled) {
        this.$emit("onClick", event);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  &--disabled {
    cursor: not-allowed;
  }
}
</style>
